import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65b50ba7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Выбор сотрудника ")
const _hoisted_2 = { style: {"min-width":"900px"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Список пуст")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Загрузка...")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_XModal = _resolveComponent("XModal")!

  return (_openBlock(), _createBlock(_component_XModal, { ref: "XModal" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_DataTable, {
          filters: $data.filters,
          "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (($data.filters) = $event)),
          globalFilterFields: ['fio'],
          paginator: $data.tableItems?.length > 10,
          rows: 10,
          value: $data.tableItems,
          class: "dataTable",
          dataKey: "id",
          filterDisplay: "row",
          removableSort: "",
          responsiveLayout: "scroll",
          selectionMode: "single",
          onRowClick: $options.tableItemsClick
        }, {
          empty: _withCtx(() => [
            _hoisted_3
          ]),
          loading: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, { field: "fio" }, {
              body: _withCtx(({ data }) => [
                _createTextVNode(_toDisplayString(data?.fio), 1)
              ]),
              filter: _withCtx(({ filterModel, filterCallback }) => [
                _createVNode(_component_InputText, {
                  modelValue: filterModel.value,
                  "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                  class: "p-column-filter",
                  placeholder: "ФИО",
                  type: "text",
                  onInput: ($event: any) => (filterCallback())
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["filters", "paginator", "value", "onRowClick"])
      ])
    ]),
    _: 1
  }, 512))
}